module.exports = __webpack_public_path__ + "img/bg.597a5f62.png";